import axios from "axios";

const isConnected = true;
const inmersysVrApi = axios.create({
	// baseURL: isConnected ? "http://localhost:5000/api/" : "http://localhost:3500/api/",
    baseURL: isConnected ? "https://xrtraining-api-dev.inmersys.dev/api/" : "http://localhost:3500/api/",
    // baseURL: isConnected ? "https://xrlearning.inmersys.com/api/" : "http://localhost:3500/api/",
});

const inmersysXRApiLocal = axios.create({
	baseURL: "http://localhost:3500/api/",
});

inmersysXRApiLocal.interceptors.request.use((config) => {
	config.headers = {
		"x-token": localStorage.getItem("x-token"),
	};
	return config;
});
inmersysVrApi.interceptors.request.use((config) => {
	config.headers = {
		"x-token": localStorage.getItem("x-token"),
	};
	return config;
});

export { inmersysVrApi, isConnected, inmersysXRApiLocal };
